import { useSearchParams, useNavigate } from 'react-router';
import Button from '@mui/material/Button';
import './index.css';

const ErrorPage = () => {
  const [searchParams] = useSearchParams();
  const errType = searchParams.get('errType');
  let navigate = useNavigate();

  if (errType === 'sessionInfo') {
    return (
      <div className="err">
        <h1>Oops, that session doesn't exist!</h1>
        <Button onClick={() => navigate('/userlookup')} variant="contained">
          Return to Application Lookup
        </Button>
      </div>
    );
  } else if (errType === 'callFailed') {
    return (
      <div className="err">
        <h1>We're having some issues getting data right now.</h1>
        <h2>Please try to log out and log back in.</h2>
      </div>
    );
  } else if (errType === '401') {
    return (
      <div className="err">
        <h1>You do not have authorization to visit this page.</h1>
      </div>
    );
  } else {
    return (
      <div className="err">
        <h1>We're having issues at the moment.</h1>
        <h2>Please contact support, or try again later.</h2>
      </div>
    );
  }
};

export default ErrorPage;
